<template>
    <div v-if="show && loaded" class="nevs-popup-container">
        <div class="nevs-popup">
            <div class="popup-form">
                <NevsSelect v-model="data.customer_id" :ajax="'select/customers'"
                            :error="validation.customer_id"
                            :nullable="true"
                            :label="$LANG.Get('fields.customer')"></NevsSelect>
                <NevsDateField v-model="data.date_from" :error="validation.date_from"
                               :label="$LANG.Get('fields.dateFrom')"></NevsDateField>
                <NevsDateField v-model="data.date_to" :error="validation.date_to"
                               :label="$LANG.Get('fields.dateTo')"></NevsDateField>
            </div>
            <div class="nevs-popup-buttons">
                <NevsButton class="error" @click="cancelClick()">
                    <i class="fa-solid fa-times"></i>
                    {{ $LANG.Get('buttons.cancel') }}
                </NevsButton>
                <NevsButton class="success" @click="confirmClick()">
                    <i class="fa-solid fa-check"></i>
                    {{ $LANG.Get('buttons.ok') }}
                </NevsButton>&nbsp;
            </div>
        </div>
    </div>
</template>

<script>
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsDateField from "@/components/nevs/NevsDateField.vue";
import moment from "moment";

export default {
    name: "ModalActivityInvoice",
    components: {NevsDateField, NevsSelect, NevsButton},
    data() {
        let defaultMonth = (moment().date() <= 10) ? moment().subtract(1, 'months') : moment();
        return {
            data: {
                customer_id: null,
                date_from: defaultMonth.startOf('month').format('YYYY-MM-DD'),
                date_to: defaultMonth.endOf('month').format('YYYY-MM-DD')
            },
            validation: {
                customer_id: '',
                date_from: '',
                date_to: ''
            },
            loaded: false
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['done'],
    watch: {
        'show'() {
            this.loaded = false;
            let defaultMonth = (moment().date() <= 10) ? moment().subtract(1, 'months') : moment();
            this.data = {
                customer_id: null,
                date_from: defaultMonth.startOf('month').format('YYYY-MM-DD'),
                date_to: defaultMonth.endOf('month').format('YYYY-MM-DD')
            };
            this.validation = {
                customer_id: '',
                date_from: '',
                date_to: ''
            };
            if (this.show) {
                this.$nextTick(() => {
                    this.loaded = true;
                });
            }
        }
    },
    methods: {
        cancelClick() {
            this.$emit('done', null);
        },
        confirmClick() {
            let valid = true;

            if (this.data.customer_id == null) {
                valid = false;
                this.validation.customer_id = this.$LANG.Get('labels.customerIdMissing');
            } else {
                this.validation.customer_id = '';
            }

            if (this.data.date_from == null) {
                valid = false;
                this.validation.date_from = this.$LANG.Get('labels.fieldMissing');
            } else {
                this.validation.date_from = '';
            }

            if (this.data.date_to == null) {
                valid = false;
                this.validation.date_to = this.$LANG.Get('labels.fieldMissing');
            } else {
                this.validation.date_to = '';
            }

            if (valid) {
                this.$emit('done', {
                    customerId: this.data.customer_id,
                    dateFrom: this.data.date_from,
                    dateTo: this.data.date_to
                });
            }
        }
    }
}
</script>

<style scoped>
.popup-form {
    padding: 10px;
}

.nevs-popup {
    max-width: 500px;
}
</style>
